import md5 from 'js-md5';

const key = 'https://admin.5laoban.com/';
const signParams = ({ path, timestamp }) => {
  const str = `${key}${path}${timestamp}${key}`;
  const signStr = md5(str);
  return signStr;
}

export {
  signParams,
}